import { render, staticRenderFns } from "./GBBottomPane.vue?vue&type=template&id=49edbce8&"
import script from "./GBBottomPane.vue?vue&type=script&lang=js&"
export * from "./GBBottomPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib'
installComponents(component, {VBottomSheet})
